import * as React from 'react'
import Milliseconds from '../../helper/milliseconds'
import { ReactElement } from 'react'

interface Props {
    message?: {
        args: {
            queries: {
                [query: string]: {
                    ct: number
                    wt: number
                }
            }
        }
    }
}

export default class Sql extends React.PureComponent<Props> {
    render = () => {
        const { message } = this.props

        let list: ReactElement | null = null
        if (message) {
            const { args } = message
            list = (
                <>
                    <p>The following queries are candidates for this problem:</p>
                    <ul>
                        {Object.entries(args.queries).map(([call, stats]) => (
                            <li key={call}>
                                <code>{call}</code> was executed {stats.ct} times and took <Milliseconds value={stats.wt} />.
                            </li>
                        ))}
                    </ul>
                </>
            )
        }

        return (
            <div>
                <p>
                    One or more database queries in this request are repeatedly executed with exactly the same arguments. For expensive
                    database calls this can lead to a significant performance decrease that is unnecessary.
                </p>

                <p>
                    N+1 performance problems usually occur when you execute SQL queries or HTTP calls in a loop and only modify the record
                    you operate on.
                </p>
                {list}
                <p>
                    A simple optimization for SQL queries is to use a <code>IN (...)</code> condition to select multiple records with a
                    single query.
                </p>
            </div>
        )
    }
}
